import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useTemplates(enterpriseId) {
  const [templates, setTemplates] = useState(null);
  const [shouldRefetch, refetch] = useState({});

  useEffect(() => {
    axios
      .get(routes.api.templates.index, { params: { enterprise_id: enterpriseId } })
      .then((response) => {
        setTemplates(response.data.data);
      });
  }, [shouldRefetch]);

  return [templates, refetch];
}
